/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

import { cssMap, jsx } from '@atlaskit/css';
import { Pressable, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	link: {
		backgroundColor: token('color.background.neutral.subtle'),
		textDecoration: 'underline',
		paddingTop: token('space.0', '0px'),
		paddingRight: token('space.0', '0px'),
		paddingBottom: token('space.0', '0px'),
		paddingLeft: token('space.0', '0px'),
		color: token('color.link'),
		'&:hover': {
			textDecoration: 'none',
		},
		'&:active': {
			color: token('color.link.pressed'),
		},
	},
});

type Props = {
	children: React.ReactNode;
	fontSize?: 'small' | 'medium' | 'large';
	onClick: () => void;
};

export const ActionButton = ({ children, onClick, fontSize }: Props) => (
	<Pressable
		onClick={onClick}
		onKeyDown={(event) => {
			if (event.key === 'Enter' || event.key === ' ') {
				event.stopPropagation();
			}
		}}
		xcss={styles.link}
	>
		<Text size={fontSize || 'small'}>{children}</Text>
	</Pressable>
);
